import React, { useState } from 'react'
import { reduxForm } from 'redux-form'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import FaqVoteModalForm from '../../Form/FaqVoteModalForm/FaqVoteModalForm'
import './FaqVoteModal.scss'

const FaqVoteModal = props => {
  const { isOpen, toggle, handleSubmit } = props

  return (
    <Modal isOpen={isOpen} toggle={toggle} contentClassName="FaqVoteModal faq-slide-modal">
      <ModalHeader toggle={toggle} />
      <ModalBody>
        <FaqVoteModalForm className="mb-3" onSubmit={handleSubmit} toggle={toggle} />
      </ModalBody>
    </Modal>
  )
}

export default reduxForm({
  form: 'FaqVoteModalForm',
})(FaqVoteModal)
